/* Cart – qty ± with AJAX update (robust selectors) */
import {
  $,
  debounce,
  patchCartFromHTML,
  postForm,
  wooRefreshFragments,
  triggerCartUpdated,
} from './utils.js';

// Guard so we bind once even after Woo refreshes the cart DOM
if (!window.__WK_CART_QTY_BOUND) window.__WK_CART_QTY_BOUND = false;
if (!window.__WK_CART_QTY_REQ)   window.__WK_CART_QTY_REQ   = { abort: null };

export function mount() {
  if (window.__WK_CART_QTY_BOUND) return;
  window.__WK_CART_QTY_BOUND = true;

  const ajaxUpdateCart = debounce(async () => {
    const form = $('.woocommerce-cart-form');
    if (!form) return;

    // Cancel previous in-flight request
    if (window.__WK_CART_QTY_REQ.abort) {
      try { window.__WK_CART_QTY_REQ.abort.abort(); } catch (_) {}
    }
    const ctrl = new AbortController();
    window.__WK_CART_QTY_REQ.abort = ctrl;

    try {
      const data = new FormData(form);
      data.append('update_cart', 'Update Cart');

      const html = await postForm(form.getAttribute('action'), data, ctrl.signal);
      patchCartFromHTML(html);   // replace items + totals
      triggerCartUpdated();      // Woo events to recalc shipping/coupons
      wooRefreshFragments();     // ensure mini-cart updates too
    } catch (err) {
      if (err?.name !== 'AbortError') console.error('[Cart] update_cart failed', err);
    } finally {
      window.__WK_CART_QTY_REQ.abort = null;
    }
  }, 200);

  // Helpers to detect +/- buttons
  const isPlus = (el) =>
    !!(el.closest?.('[data-qty-act="+"], [data-act="+"]'))
    || !!(el.closest?.('.wk-qty__plus, .qty-plus, .plus'));

  const isMinus = (el) =>
    !!(el.closest?.('[data-qty-act="-"], [data-act="-"]'))
    || !!(el.closest?.('.wk-qty__minus, .qty-minus, .minus'));

  function findQtyInput(fromEl) {
    // Prefer a quantity container first
    const container =
      fromEl.closest?.('.quantity, .wk-qty, td.product-quantity, .cart_item') || document;
    let input = container.querySelector?.('input.qty');

    // Fallbacks nearby
    if (!input) {
      input =
        fromEl.previousElementSibling?.matches?.('input.qty') ? fromEl.previousElementSibling :
        fromEl.nextElementSibling?.matches?.('input.qty')     ? fromEl.nextElementSibling :
        null;
    }
    return input || null;
  }

  // Click on any +/- in the document (works after DOM swaps)
  document.addEventListener('click', (e) => {
    const t = e.target;
    const plus  = isPlus(t);
    const minus = isMinus(t);
    if (!plus && !minus) return;

    // Only act if we’re on a cart page with a form present
    if (!$('.woocommerce-cart-form')) return;

    e.preventDefault();

    const input = findQtyInput(t);
    if (!input) return;

    const step = Number.isFinite(parseFloat(input.step)) ? parseFloat(input.step) : 1;
    const min  = Number.isFinite(parseFloat(input.min))  ? parseFloat(input.min)  : 0;
    const max  = Number.isFinite(parseFloat(input.max))  ? parseFloat(input.max)  : Infinity;

    const current = String(input.value || '').replace(',', '.');
    let val = Number.isFinite(parseFloat(current)) ? parseFloat(current) : min || 0;

    if (minus) val = Math.max(min, val - step);
    if (plus)  val = Math.min(max, val + step);

    const prec = (step.toString().split('.')[1] || '').length;
    val = Number(val.toFixed(Math.max(0, prec)));

    input.value = String(val);
    input.dispatchEvent(new Event('change', { bubbles: true }));

    ajaxUpdateCart();
  });

  // Typing normalisation + manual change → AJAX
  document.addEventListener('input', (e) => {
    if (!e.target.matches('input.qty')) return;
    e.target.value = e.target.value.replace(',', '.');
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('input.qty')) return;
    if (!$('.woocommerce-cart-form')) return;
    ajaxUpdateCart();
  });
}
